import { useState } from "react";
import { toast } from "sonner";
import { registerInterest } from "@/lib/api";

export default function ComingSoon({ area, eyebrow, title, body, image, accent = "gold" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await registerInterest(email, area);
      toast.success("You're on the list. We'll be in touch.");
      setEmail("");
    } catch {
      toast.error("Couldn't register your interest. Try again shortly.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative min-h-[70vh] flex items-center" data-testid={`coming-soon-${area}`}>
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${image})` }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-ink/70" aria-hidden />
      <div className="relative max-w-4xl mx-auto px-6 md:px-10 py-32 text-white">
        <p className={`overline ${accent === "gold" ? "text-gold" : "text-white/70"}`}>{eyebrow}</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight mt-4">
          {title}
        </h1>
        <p className="mt-6 max-w-2xl text-lg text-white/80 leading-relaxed">{body}</p>

        <form
          onSubmit={submit}
          className="mt-10 flex flex-col sm:flex-row gap-3 max-w-xl"
          data-testid={`interest-form-${area}`}
        >
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Notify me at..."
            data-testid={`interest-email-${area}`}
            className="flex-1 bg-white/10 ring-1 ring-white/20 rounded-full px-5 py-3 text-sm outline-none placeholder-white/50 focus:ring-gold"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid={`interest-submit-${area}`}
            className="btn-gold rounded-full px-6 py-3 text-sm font-medium"
          >
            {loading ? "Joining..." : "Join the waitlist"}
          </button>
        </form>

        <p className="mt-6 text-xs text-white/50 tracking-wide">
          We respect your inbox. One thoughtful update at a time.
        </p>
      </div>
    </section>
  );
}
